export const recaptchaKey = '6LeZxrkrAAAAANxukFWn5Ps0PWkqo2Le4OXdvXi9';